<template>
<div :class="$style.dropdown">
    <span :class="$style.label">{{label}}</span>
    <select v-model='selection' v-bind:id="nodeId">
        <option :value="null" disabled/>

        <template v-for="item in items">
            <option :key="item.id" :value="item[id]">
                {{item[text]}}
            </option>
        </template>
    </select>
<!-- <sup style="color:lightgrey;font-size: 8pt;">{{name}}</sup> -->
</div>
</template>

<script>
export default {
    name: 'dropDown',
    mounted: function(){
        this.init();
    },
    props: {
        label: {
            type: String,
            requied: true
        },
        reset: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        id: {
            type: String,
            required: false,
            default: 'id'
        },
        nodeId: {
            type: String,
            required: false,
            default: ''
        },
        text: {
            type: String,
            required: false,
            default: 'name'
        }
    },
    data: function(){
        return {
            selection: null
        }
    },
    methods: {
        init: function(){

        }
    },
    computed: {
        reset_trigger: function(){
            return this.reset;
        }
    },
    watch: {
        selection: function(){
            this.$emit('selection',{
                name: this.name,
                selection: this.selection
            })
        },
        reset_trigger: function(){
            if(this.reset_trigger===true){
                this.selection = null;
            }
        }
    }
}
</script>

<style module>
.dropdown select{
    width: 100%;
    margin-bottom: 10px;
}

select option:checked{
    font-weight: bold !important;
}

.label{
    font-size: 1em;
}
</style>